import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import topicsReducer from './slices/topicsSlice';
import postsReducer from './slices/postsSlice';
import commentsReducer from './slices/commentsSlice';
import reportsReducer from './slices/reportsSlice';

export default configureStore({
  reducer: {
    auth: authReducer,
    topics: topicsReducer,
    posts: postsReducer,
    comments: commentsReducer,
    reports: reportsReducer
  },
});